import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';

import * as Actions from './keyboard.actions';
import { KeyboaardPartialState } from './keyboard.reducer';
import { getShowHelp } from './keyboard.selectors';

@Injectable({
  providedIn: 'root',
})
export class KeyboardFacade {
  showHelp$ = this.store.pipe(select(getShowHelp));

  constructor(private store: Store<KeyboaardPartialState>) {}

  save(entityName: string) {
    this.store.dispatch(Actions.keyboardSave({ entity: entityName }));
  }

  add(entityName: string) {
    this.store.dispatch(Actions.keyboardAdd({ entity: entityName }));
  }

  delete(entityName: string) {
    this.store.dispatch(Actions.keyboardDelete({ entity: entityName }));
  }

  openFilters(entityName: string) {
    this.store.dispatch(Actions.keyboardOpenFilters({ entity: entityName }));
  }

  applyFilters(entityName: string) {
    this.store.dispatch(Actions.keyboardApplyFilters({ entity: entityName }));
  }

  resetFilters(entityName: string) {
    this.store.dispatch(Actions.keyboardResetFilters({ entity: entityName }));
  }

  showHelp(show: boolean) {
    this.store.dispatch(Actions.showHelp({ show }));
  }
}
